module.exports = __webpack_public_path__ + "static/media/40-8.96621244.mp3";